import script from "./EvaluationWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./EvaluationWizard.vue?vue&type=script&setup=true&lang=js"

import "./EvaluationWizard.vue?vue&type=style&index=0&id=4bcb4698&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcb4698"]])

export default __exports__